import React from 'react'
import { useTranslation } from '@structura/i18n'

interface CombinationFactorDetailsProps
{
  combination: any
}

// Factor table (γ, ψ, γ·ψ per load category) for one analysed load combination.
// Rendered in the response control panel directly below the section's
// "Vis detaljer for valgt lastkombinasjon" button.
const CombinationFactorDetails: React.FC<CombinationFactorDetailsProps> = ({ combination }) =>
{
  const { t } = useTranslation()

  const limitState: string = combination.limitState || combination.LimitState || ''
  const leading: string = combination.leadingCategory || combination.LeadingCategory || 'None'
  const loadFactors: any[] = combination.loadFactors || combination.LoadFactors || []

  if (!loadFactors || loadFactors.length === 0)
  {
    return <div className="text-muted small mb-2">{t('beam.response.noFactorDetails')}</div>
  }

  return (
    <div className="border rounded p-2 mb-2 bg-light-subtle">
      <div className="small mb-2">
        <span className="badge bg-secondary me-2">{limitState || t('beam.response.uls')}</span>
        <span className="text-muted">
          {leading === 'None' ? t('beam.results.noVariableLeading') : t('beam.response.leadingNoColon', { category: leading })}
        </span>
      </div>
      <div className="table-responsive">
        <table className="table table-sm table-bordered align-middle mb-0" style={{ fontSize: '0.8rem' }}>
          <thead className="table-light">
            <tr>
              <th style={{ width: '30%' }}>{t('beam.response.thLoadCategory')}</th>
              <th style={{ width: '15%' }}>{t('beam.results.thLeading')}</th>
              <th style={{ width: '15%' }}>γ</th>
              <th style={{ width: '15%' }}>ψ</th>
              <th style={{ width: '25%' }}>γ·ψ</th>
            </tr>
          </thead>
          <tbody>
            {loadFactors.map((factor, index) => {
              const category = factor.category || factor.Category || ''
              const isLeading = factor.isLeading ?? factor.IsLeading ?? false
              const gamma = typeof factor.gamma === 'number' ? factor.gamma : factor.Gamma
              const psi = typeof factor.psi === 'number' ? factor.psi : factor.Psi
              const combined = typeof factor.factor === 'number' ? factor.factor : factor.Factor

              return (
                <tr key={index}>
                  <td>{category}</td>
                  <td>{isLeading ? <span className="badge bg-success">{t('beam.response.badgeLeading')}</span> : ''}</td>
                  <td>{gamma !== undefined ? gamma.toFixed(2) : '—'}</td>
                  <td>{psi !== undefined ? psi.toFixed(2) : '—'}</td>
                  <td>{combined !== undefined ? combined.toFixed(2) : '—'}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default CombinationFactorDetails
